// console.log(process.env.NODE_ENV);
// console.log(process.env.API_URL);

// console.log("We also like to peek at the console 😁");
import { Init } from "./init";
// import { SwupTransition } from "./swup";

document.addEventListener("DOMContentLoaded", () => {
	Init();
	// SwupTransition();

	// Menu Flutuante
	if (document.getElementById('floating-menu')) initFloatingMenu();

	// Modal de Reserva
	initReservaModal();
});

function initFloatingMenu() {
	const mainHeader = document.getElementById('main-header');
	const floatingMenu = document.getElementById('floating-menu');
	const menuTrigger = document.getElementById('menu-trigger');
	const mobileMenuTrigger = document.getElementById('mobile-menu-trigger');
	const floatingMenuTrigger = document.getElementById('floating-menu-trigger');
	const sideMenu = document.getElementById('side-menu');
	const closeSideMenu = document.getElementById('close-side-menu');
	const menuOverlay = document.getElementById('menu-overlay');

	let lastScrollY = window.scrollY;
	let headerVisible = true;

	// Controlar visibilidade do menu flutuante baseado no scroll
	function handleScroll() {
		const currentScrollY = window.scrollY;
		const headerHeight = mainHeader.offsetHeight;

		// Verificar se o header está visível
		const headerBottom = mainHeader.getBoundingClientRect().bottom;
		const isHeaderVisible = headerBottom > 0;

		// Mostrar menu flutuante apenas quando header não está visível
		if (!isHeaderVisible && currentScrollY > headerHeight) {
			floatingMenu.classList.remove('opacity-0', 'invisible');
			floatingMenu.classList.add('opacity-100', 'visible');
		} else {
			floatingMenu.classList.add('opacity-0', 'invisible');
			floatingMenu.classList.remove('opacity-100', 'visible');
		}

		lastScrollY = currentScrollY;
	}

	// Abrir menu lateral
	menuTrigger.addEventListener('click', (e) => {
		// Verificar se o clique foi no botão de reservar
		const reservaButton = e.target.closest('a[href="#reservar"], .reserva-trigger');
		if (reservaButton) {
			// Se for o botão de reservar, não abre o menu, apenas deixa o modal ser aberto
			return;
		}

		// Se não for o botão de reservar, abre o menu lateral
		sideMenu.classList.remove('translate-x-full');
		menuOverlay.classList.remove('opacity-0', 'invisible');
		menuOverlay.classList.add('opacity-100', 'visible');
		
	});

	mobileMenuTrigger.addEventListener('click', (e) => {
		// Verificar se o clique foi no botão de reservar
		const reservaButton = e.target.closest('a[href="#reservar"], .reserva-trigger');
		if (reservaButton) {
			// Se for o botão de reservar, não abre o menu, apenas deixa o modal ser aberto
			return;
		}

		// Se não for o botão de reservar, abre o menu lateral
		sideMenu.classList.remove('translate-x-full');
		menuOverlay.classList.remove('opacity-0', 'invisible');
		menuOverlay.classList.add('opacity-100', 'visible');
		
	});

	floatingMenuTrigger.addEventListener('click', (e) => {
		// Verificar se o clique foi no botão de reservar
		const reservaButton = e.target.closest('a[href="#reservar"], .reserva-trigger');
		if (reservaButton) {
			// Se for o botão de reservar, não abre o menu, apenas deixa o modal ser aberto
			return;
		}

		// Se não for o botão de reservar, abre o menu lateral
		sideMenu.classList.remove('translate-x-full');
		menuOverlay.classList.remove('opacity-0', 'invisible');
		menuOverlay.classList.add('opacity-100', 'visible');
		
	});

	// Fechar menu lateral
	function closeSideMenuFunc() {
		sideMenu.classList.add('translate-x-full');
		menuOverlay.classList.add('opacity-0', 'invisible');
		menuOverlay.classList.remove('opacity-100', 'visible');
		document.body.style.overflow = '';
	}

	closeSideMenu.addEventListener('click', closeSideMenuFunc);
	menuOverlay.addEventListener('click', closeSideMenuFunc);

	// Adicionar listener de scroll
	window.addEventListener('scroll', handleScroll);

	// Verificar estado inicial
	handleScroll();
}

function initReservaModal() {
	const reservaModal = document.getElementById('reserva-modal');
	const closeReservaModal = document.getElementById('close-reserva-modal');

	// Abrir modal ao clicar em links com #reservar
	document.addEventListener('click', (e) => {
		const target = e.target.closest('a[href="#reservar"], .reserva-trigger');
		if (target) {
			e.preventDefault();
			openReservaModal();
		}
	});

	// Função para abrir modal
	function openReservaModal() {
		reservaModal.classList.remove('opacity-0', 'invisible');
		reservaModal.classList.add('opacity-100', 'visible');
		

		// Inicializar componentes do modal
		setTimeout(() => {
			initModalComponents();
		}, 100);
	}

	// Função para inicializar componentes do modal
	function initModalComponents() {
		// Inicializar date pickers
		initModalDatePickers();

		// Inicializar incrementador de quartos e hóspedes
		initModalQuartosHospedes();
	}

	// Inicializar date pickers do modal
	function initModalDatePickers() {
		// Verificar se Flatpickr está disponível
		if (typeof flatpickr === 'undefined') {
			console.warn('Flatpickr não está carregado');
			return;
		}

		// Configurações básicas para o Flatpickr
		const fpConfig = {
			locale: 'pt',
			dateFormat: 'd-m-Y',
			minDate: 'today',
			disableMobile: 'true',
			animate: true,
			shorthandCurrentMonth: true,
			showMonths: 1,
			onChange: function (selectedDates, dateStr, instance) {
				// Formatar data com zeros à esquerda (dd-mm-yyyy)
				if (selectedDates.length > 0) {
					const date = selectedDates[0];
					const day = String(date.getDate()).padStart(2, '0');
					const month = String(date.getMonth() + 1).padStart(2, '0');
					const year = date.getFullYear();
					instance.input.value = `${day}-${month}-${year}`;
				}
				
				// Atualizar data mínima do check-out
				const checkoutInput = document.getElementById('checkout-modal');
				if (checkoutInput && checkoutInput._flatpickr) {
					checkoutInput._flatpickr.set('minDate', selectedDates[0] || 'today');
				}
			}
		};

		// Inicializar Check-in do modal
		const checkinModal = document.getElementById('checkin-modal');
		if (checkinModal && !checkinModal._flatpickr) {
			flatpickr(checkinModal, fpConfig);
		}

		// Inicializar Check-out do modal
		const checkoutModal = document.getElementById('checkout-modal');
		if (checkoutModal && !checkoutModal._flatpickr) {
			flatpickr(checkoutModal, fpConfig);
		}
	}

	// Inicializar incrementador de quartos e hóspedes do modal
	function initModalQuartosHospedes() {
		let quartos = 1;
		let adultos = 2;
		let criancas = 0;

		// Valores
		const quartosValue = document.getElementById('quartos-value-modal');
		const adultosValue = document.getElementById('adultos-value-modal');
		const criancasValue = document.getElementById('criancas-value-modal');

		// Botões dos quartos
		const quartosMinus = document.getElementById('quartos-minus-modal');
		const quartosPlus = document.getElementById('quartos-plus-modal');

		// Botões dos adultos
		const adultosMinus = document.getElementById('adultos-minus-modal');
		const adultosPlus = document.getElementById('adultos-plus-modal');

		// Botões das crianças
		const criancasMinus = document.getElementById('criancas-minus-modal');
		const criancasPlus = document.getElementById('criancas-plus-modal');

		// Função para atualizar valores e estados dos botões
		const updateValues = () => {
			// Atualizar valores exibidos no modal
			if (quartosValue) quartosValue.textContent = quartos;
			if (adultosValue) adultosValue.textContent = adultos;
			if (criancasValue) criancasValue.textContent = criancas;

			// Atualizar estado dos botões do modal
			if (quartosMinus) quartosMinus.disabled = quartos <= 1;
			if (quartosPlus) quartosPlus.disabled = quartos >= 10;
			if (adultosMinus) adultosMinus.disabled = adultos <= 1;
			if (adultosPlus) adultosPlus.disabled = adultos >= 20;
			if (criancasMinus) criancasMinus.disabled = criancas <= 0;
			if (criancasPlus) criancasPlus.disabled = criancas >= 10;

			// Sincronizar com a hero
			syncWithHero();
		};

		// Função para sincronizar com a hero
		const syncWithHero = () => {
			// Só sincronizar se os elementos da hero existirem
			if (!document.getElementById('checkin-date')) {
				return; // Não há formulário na hero, não sincronizar
			}

			// Sincronizar valores com a hero
			const heroQuartosValue = document.getElementById('quartos-value');
			const heroAdultosValue = document.getElementById('adultos-value');
			const heroCriancasValue = document.getElementById('criancas-value');

			if (heroQuartosValue) heroQuartosValue.textContent = quartos;
			if (heroAdultosValue) heroAdultosValue.textContent = adultos;
			if (heroCriancasValue) heroCriancasValue.textContent = criancas;

			// Atualizar texto da hero
			updateHeroText();
		};

		// Função para atualizar texto da hero
		const updateHeroText = () => {
			const heroText = document.getElementById('quartos-hospedes-text');
			if (heroText) {
				const quartosText = quartos === 1 ? 'Quarto' : 'Quartos';
				const totalHospedes = adultos + criancas;
				const hospedesText = totalHospedes === 1 ? 'hóspede' : 'hóspedes';

				let textoCompleto = `${quartos} ${quartosText}, ${totalHospedes} ${hospedesText}`;

				// Adicionar detalhes se houver crianças
				if (criancas > 0) {
					const adultosText = adultos === 1 ? 'adulto' : 'adultos';
					const criancasText = criancas === 1 ? 'criança' : 'crianças';
					textoCompleto += ` (${adultos} ${adultosText}, ${criancas} ${criancasText})`;
				}

				heroText.textContent = textoCompleto;
			}
		};

		// Função para carregar valores da hero
		const loadFromHero = () => {
			// Só carregar se os elementos da hero existirem
			if (!document.getElementById('checkin-date')) {
				return; // Não há formulário na hero, usar valores padrão
			}

			const heroQuartosValue = document.getElementById('quartos-value');
			const heroAdultosValue = document.getElementById('adultos-value');
			const heroCriancasValue = document.getElementById('criancas-value');

			if (heroQuartosValue) quartos = parseInt(heroQuartosValue.textContent) || 1;
			if (heroAdultosValue) adultos = parseInt(heroAdultosValue.textContent) || 1;
			if (heroCriancasValue) criancas = parseInt(heroCriancasValue.textContent) || 0;

			updateValues();
		};

		// Event listeners para quartos
		if (quartosMinus) {
			quartosMinus.addEventListener('click', (e) => {
				e.stopPropagation();
				if (quartos > 1) {
					quartos--;
					updateValues();
				}
			});
		}

		if (quartosPlus) {
			quartosPlus.addEventListener('click', (e) => {
				e.stopPropagation();
				if (quartos < 10) {
					quartos++;
					updateValues();
				}
			});
		}

		// Event listeners para adultos
		if (adultosMinus) {
			adultosMinus.addEventListener('click', (e) => {
				e.stopPropagation();
				if (adultos > 1) {
					adultos--;
					updateValues();
				}
			});
		}

		if (adultosPlus) {
			adultosPlus.addEventListener('click', (e) => {
				e.stopPropagation();
				if (adultos < 20) {
					adultos++;
					updateValues();
				}
			});
		}

		// Event listeners para crianças
		if (criancasMinus) {
			criancasMinus.addEventListener('click', (e) => {
				e.stopPropagation();
				if (criancas > 0) {
					criancas--;
					updateValues();
				}
			});
		}

		if (criancasPlus) {
			criancasPlus.addEventListener('click', (e) => {
				e.stopPropagation();
				if (criancas < 10) {
					criancas++;
					updateValues();
				}
			});
		}

		// Carregar valores iniciais da hero
		loadFromHero();

		// Configurar sincronização bidirecional
		setupBidirectionalSync();
	}

	// Função para configurar sincronização bidirecional
	function setupBidirectionalSync() {
		// Só configurar sincronização se os elementos da hero existirem
		if (!document.getElementById('checkin-date')) {
			return; // Não há formulário na hero, não sincronizar
		}

		// Sincronizar datas quando mudar na hero
		const heroCheckin = document.getElementById('checkin-date');
		const heroCheckout = document.getElementById('checkout-date');
		const modalCheckin = document.getElementById('checkin-modal');
		const modalCheckout = document.getElementById('checkout-modal');

		// Hero -> Modal
		if (heroCheckin && modalCheckin) {
			heroCheckin.addEventListener('change', () => {
				if (heroCheckin._flatpickr && modalCheckin._flatpickr) {
					modalCheckin._flatpickr.setDate(heroCheckin._flatpickr.selectedDates[0]);
				}
			});
		}

		if (heroCheckout && modalCheckout) {
			heroCheckout.addEventListener('change', () => {
				if (heroCheckout._flatpickr && modalCheckout._flatpickr) {
					modalCheckout._flatpickr.setDate(heroCheckout._flatpickr.selectedDates[0]);
				}
			});
		}

		// Modal -> Hero
		if (modalCheckin && heroCheckin) {
			modalCheckin.addEventListener('change', () => {
				if (modalCheckin._flatpickr && heroCheckin._flatpickr) {
					heroCheckin._flatpickr.setDate(modalCheckin._flatpickr.selectedDates[0]);
				}
			});
		}

		if (modalCheckout && heroCheckout) {
			modalCheckout.addEventListener('change', () => {
				if (modalCheckout._flatpickr && heroCheckout._flatpickr) {
					heroCheckout._flatpickr.setDate(modalCheckout._flatpickr.selectedDates[0]);
				}
			});
		}

		// Sincronizar incrementadores da hero com o modal
		setupHeroIncrementerSync();
	}

	// Função para sincronizar incrementadores da hero
	function setupHeroIncrementerSync() {
		// Só sincronizar se os elementos da hero existirem
		if (!document.getElementById('checkin-date')) {
			return; // Não há formulário na hero, não sincronizar
		}

		// Botões da hero
		const heroQuartosMinus = document.getElementById('quartos-minus');
		const heroQuartosPlus = document.getElementById('quartos-plus');
		const heroAdultosMinus = document.getElementById('adultos-minus');
		const heroAdultosPlus = document.getElementById('adultos-plus');
		const heroCriancasMinus = document.getElementById('criancas-minus');
		const heroCriancasPlus = document.getElementById('criancas-plus');

		// Valores do modal
		const modalQuartosValue = document.getElementById('quartos-value-modal');
		const modalAdultosValue = document.getElementById('adultos-value-modal');
		const modalCriancasValue = document.getElementById('criancas-value-modal');

		// Hero -> Modal
		if (heroQuartosMinus && modalQuartosValue) {
			heroQuartosMinus.addEventListener('click', () => {
				setTimeout(() => {
					const currentValue = parseInt(modalQuartosValue.textContent) || 1;
					modalQuartosValue.textContent = currentValue;
				}, 10);
			});
		}

		if (heroQuartosPlus && modalQuartosValue) {
			heroQuartosPlus.addEventListener('click', () => {
				setTimeout(() => {
					const currentValue = parseInt(modalQuartosValue.textContent) || 1;
					modalQuartosValue.textContent = currentValue;
				}, 10);
			});
		}

		if (heroAdultosMinus && modalAdultosValue) {
			heroAdultosMinus.addEventListener('click', () => {
				setTimeout(() => {
					const currentValue = parseInt(modalAdultosValue.textContent) || 1;
					modalAdultosValue.textContent = currentValue;
				}, 10);
			});
		}

		if (heroAdultosPlus && modalAdultosValue) {
			heroAdultosPlus.addEventListener('click', () => {
				setTimeout(() => {
					const currentValue = parseInt(modalAdultosValue.textContent) || 1;
					modalAdultosValue.textContent = currentValue;
				}, 10);
			});
		}

		if (heroCriancasMinus && modalCriancasValue) {
			heroCriancasMinus.addEventListener('click', () => {
				setTimeout(() => {
					const currentValue = parseInt(modalCriancasValue.textContent) || 0;
					modalCriancasValue.textContent = currentValue;
				}, 10);
			});
		}

		if (heroCriancasPlus && modalCriancasValue) {
			heroCriancasPlus.addEventListener('click', () => {
				setTimeout(() => {
					const currentValue = parseInt(modalCriancasValue.textContent) || 0;
					modalCriancasValue.textContent = currentValue;
				}, 10);
			});
		}
	}

	// Função para fechar modal
	function closeReservaModalFunc() {
		reservaModal.classList.add('opacity-0', 'invisible');
		reservaModal.classList.remove('opacity-100', 'visible');
		document.body.style.overflow = '';

		// Destruir instâncias do Flatpickr se existirem
		const checkinModal = document.getElementById('checkin-modal');
		const checkoutModal = document.getElementById('checkout-modal');

		if (checkinModal && checkinModal._flatpickr) {
			// checkinModal._flatpickr.destroy();
		}

		if (checkoutModal && checkoutModal._flatpickr) {
			// checkoutModal._flatpickr.destroy();
		}
	}

	// Fechar modal ao clicar no X
	closeReservaModal.addEventListener('click', closeReservaModalFunc);

	// Fechar modal ao clicar no backdrop
	reservaModal.addEventListener('click', (e) => {
		if (e.target === reservaModal) {
			closeReservaModalFunc();
		}
	});

	// Fechar modal com ESC
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !reservaModal.classList.contains('invisible')) {
			closeReservaModalFunc();
		}
	});
}
